{
  "name": "bloom",
  "doc": "The opposite of the tunnel: a push outward from the centre. The waves open like petals and dissolve at the edges; a slow hue drift colours the rings as they age.",
  "cx": 0.5,
  "cy": 0.5,
  "zoom": 0.985,
  "zoomexp": 1.0,
  "rot": 0.0,
  "rotr": 0.0,
  "dx": 0,
  "dy": 0,
  "sx": 1,
  "sy": 1,
  "warp": 0.004,
  "warpScale": 3,
  "warpSpeed": 0.2,
  "decay": 0.955,
  "invert": 0,
  "hueShift": 0.006,
  "darkenCenter": 0.0,
  "wave": "CIRCLE",
  "waveColor": 2,
  "shapes": 1,
  "energy": [
    0.2,
    0.65
  ]
}